import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import Logo from "./Logo";

const EXPLORE = [
  { to: "/playlists", label: "Playlists" },
  { to: "/sessions", label: "Sessions" },
  { to: "/partners", label: "Partners" },
  { to: "/pricing", label: "Pricing" },
];

const RESOURCES = [
  { to: "/faq", label: "FAQ" },
  { to: "/status", label: "Status" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
];

function TikTokIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.78.12V9.4a6.13 6.13 0 0 0-.78-.05 5.94 5.94 0 1 0 5.94 5.94V9.29a7.35 7.35 0 0 0 4.3 1.38V7.58a4.33 4.33 0 0 1-3.5-1.76z" />
    </svg>
  );
}

function LinkColumn({ heading, links, testid }) {
  return (
    <div className="flex flex-col items-center gap-4" data-testid={testid}>
      <p className="footer-heading">{heading}</p>
      {links.map((l) => (
        <Link key={l.to} to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="footer-link text-[0.95rem]">
          {l.label}
        </Link>
      ))}
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="footer-wash mt-16" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 pt-16 pb-8">
        <div className="grid md:grid-cols-3 gap-12 md:gap-8">
          <div className="flex flex-col items-center gap-4">
            <Logo />
            <p className="text-[0.95rem] text-dusk">Music. Memories. Moments.</p>
            <div className="flex items-center gap-3">
              <a href="https://www.instagram.com/tapinsound" target="_blank" rel="noopener noreferrer" aria-label="Tap In Sound on Instagram" data-testid="social-instagram" className="social-icon">
                <Instagram size={18} />
              </a>
              <a href="https://www.linkedin.com/company/tap-in-sound" target="_blank" rel="noopener noreferrer" aria-label="Tap In Sound on LinkedIn" data-testid="social-linkedin" className="social-icon">
                <Linkedin size={18} />
              </a>
              <a href="#" aria-label="Tap In on TikTok" data-testid="social-tiktok" className="social-icon">
                <TikTokIcon />
              </a>
            </div>
          </div>
          <LinkColumn heading="Explore" links={EXPLORE} testid="footer-explore" />
          <LinkColumn heading="Resources" links={RESOURCES} testid="footer-resources" />
        </div>
        <div className="divider-line mt-14" />
        <p className="text-center text-sm text-dusk/80 pt-6" data-testid="footer-copyright">
          © 2026 Tap In Sound. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
